import { useMemo } from "react";
import InformationsMetaTags from "@/components/MetaTags/InformationsMetaTags";
import InformationsList from "@/components/InformationsList";
import config from "@/lib/config";
import styles from "@/styles/Informations.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function Informations() {
  const key = useMemo(() => {
    return config.information["vod"];
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(InformationsMetaTags, {}), /*#__PURE__*/_jsx("div", {
      className: styles.container,
      children: /*#__PURE__*/_jsx(InformationsList, {
        id: key
      })
    })]
  });
}